module.exports = __webpack_public_path__ + "img/participant-logo.af9ce9c.png";